<template>
<div class="vliveFollow">
    <div>
        <!--<el-switch v-model="follow.isopenmp" active-text="关闭后，观看端将不会显示此关注栏" @change="switchStatus"></el-switch>-->
        <span class="switch"  @click.stop="switchStatus">
            <el-switch v-model="follow.isopenmp" active-text="关闭后，观看端将不会显示此关注栏" disabled></el-switch>
        </span>
    </div>
    <div class="live-follow" v-if="follow.isopenmp">
        <div class="left user_default_image">
            <img :src="follow.coverPicture.furl +'?'+timestamp" alt="" v-if="follow.coverPicture.furl">
        </div>
        <div class="right">
            <el-button class="btn" type="text" size="small" @click="handleOpenHostEdit">修改账户信息</el-button>
        </div>
    </div>
    <div class="live-follow" v-if="follow.isopenmp">
        <div class="left">
            <upload class="headImage" :imgRule="imgRule"  @setImage="_editQr" :uploadType="uploadType" ref="mpqrPic"></upload>
        </div>
        <div class="right">
            <el-button class="btn" type="text" size="small">更换二维码</el-button>
        </div>
    </div>
    <vliveHostEdit ref="vliveHostEdit" @setHostInfo="_setHostInfo"></vliveHostEdit>
</div>
</template>

<script>
import Upload from 'base/upload/upload'
import VliveHostEdit from 'views/cms/vlive/components/vliveHostEdit'
import {mapGetters, mapActions} from 'vuex'
import {editVliveQRCodeStatus, editVliveQRCode, editVliveWeChatFollow} from 'api/api'
import {formatFileInfo} from 'common/js/tools'
import {vliveMsg} from 'api/message'
export default {
    name: 'vliveFollow',
    data() {
        return {
            timestamp: new Date().getTime(), // 时间戳
            follow: {
                isopenmp: false,
                coverPicture: {
                    bucket: '',
                    fname: '',
                    fsize: '',
                    width: '',
                    height: '',
                    key: '',
                    mimeType: '',
                    objecttype: '',
                    furl: ''
                },
                openmpname: '',
                mpqrPic: {
                    bucket: '',
                    fname: '',
                    fsize: '',
                    width: '',
                    height: '',
                    key: '',
                    mimeType: '',
                    objecttype: '',
                    furl: ''
                }
            },
            imgRule: {
                cls: 'icon_default_image',
                accept: 'image/png,image/jpeg',
                size: 5,
                width: '',
                height: ''
            },
            cropperOption: {
                fixedNumber: [100, 100], // 截图框的宽高比例
                enlarge: 1, // 图片根据截图框输出比例倍数
                autoCropWidth: 100, // 默认生成截图框宽度
                autoCropHeight: 100 // 默认生成截图框高度
            },
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            settingType: 'isopenmp' // isopenpreview 预告片 isopencover 引导封面 isopenmp 关注公众号 isopenenroll 报名
        }
    },
    mounted() {
    },
    methods: {
        // 开启/关闭公众号关注
        switchStatus() {
            let status = !this.follow.isopenmp ? 1 : 0
            let tip = !this.follow.isopenmp ? '开启公众号关注' : '关闭公众号关注'
            this.$confirm(`确定${tip}？`, '提示', {
                cancelButtonText: '取消',
                confirmButtonText: '确定'
            }).then(() => {
                this._editStatus(status, tip)
            })
        },
        // 打开账户编辑框
        handleOpenHostEdit() {
            let obj = {
                name: this.follow.openmpname,
                fileInfo: this.follow.coverPicture
            }
            this.$refs.vliveHostEdit.openDialog(obj)
        },
        // 提交二维码
        _editQr(file) {
            this.timestamp = new Date().getTime()
            this.setLoading(true)
            editVliveQRCode({
                data: {
                    assetinnerid: this.vliveModel.assetinnerid,
                    coverPicture: formatFileInfo(file)
                },
                success: data => {
                    this.$message.success('保存成功！')
                    this.follow.mpqrPic = file
                    this.setVliveModelFollow(Object.assign({}, this.follow))
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 提交关闭/开启公众号关注
        _editStatus (status, tip) {
            this.setLoading(true)
            editVliveQRCodeStatus({
                data: {
                    assetinnerid: this.vliveModel.assetinnerid,
                    settingType: this.settingType,
                    settingValue: status
                },
                success: data => {
                    this.$message.success(`${tip}成功！`)
                    this.follow.isopenmp = !this.follow.isopenmp
                    this.setVliveModelFollow(Object.assign({}, this.follow))
                    this.setLoading(false)
                },
                error: data => {
                    this.follow.isopenmp = !this.follow.isopenmp
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 提交账户信息
        _setHostInfo(name, file) {
            this.timestamp = new Date().getTime()
            this.setLoading(true)
            editVliveWeChatFollow({
                data: {
                    assetinnerid: this.vliveModel.assetinnerid,
                    openmpname: name,
                    coverPicture: formatFileInfo(file)
                },
                success: data => {
                    this.$message.success(vliveMsg.submitHostInfo.successMsg)
                    this.follow.openmpname = name
                    this.follow.coverPicture = file
                    this.setVliveModelFollow(Object.assign({}, this.follow))
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setVliveModelFollow',
            'setLoading'
        ])
    },
    filters: {},
    watch: {
        vliveModel: {
            handler: function() {
                this.follow = Object.assign({}, this.vliveModel.follow)
            },
            deep: true
        },
        follow: {
            handler: function() {
                let _this = this
                this.$nextTick(() => {
                    if (_this.follow.isopenmp && _this.follow.mpqrPic) {
                        _this.$refs.mpqrPic.setImage(_this.follow.mpqrPic.furl + '?' + _this.timestamp)
                    }
                })
            },
            deep: true
        }
    },
    computed: {
        ...mapGetters([
            'vliveModel'
        ])
    },
    components: {
        Upload,
        VliveHostEdit
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.vliveFollow {
    .live-follow{
        @include flexBox(flex-start);
        margin-top: 30px;
        .icon, .avatar-uploader{
            box-sizing: border-box;
            height: 100px;
            width: 100px;
        }
        .left.user_default_image{
            border: 1px dashed $line;
            border-radius: 6px;
        }
        .left{
            height: 100px;
            width: 100px;
            img{
                height: 100px;
                width: 100px;
            }
            .icon_user{
                &:before{
                    height: 20px;
                    width: 20px;
                }
                background-attachment:fixed;
                background-position: 30% 20%;
            }
        }
        .right{
            align-self: flex-end;
        }
    }
    .el-icon-plus:before{
        content: '';
    }
}
</style>
